export default __webpack_public_path__ + "static/media/oktalogo.b9af3796.png";